import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { apiClient } from '@/lib/api'
import { useAuth } from '@/stores/authStore'
import type { SessionResponse } from '@/lib/types'

export function useSessionQuery() {
  const { setSession, clear, markHydrated } = useAuth()

  const query = useQuery<SessionResponse | null>({
    queryKey: ['session'],
    queryFn: async () => {
      try {
        const r = await apiClient.get<SessionResponse>('/api/v1/auth/me')
        return r.data
      } catch {
        return null
      }
    },
    retry: false,
    staleTime: 60_000,
  })

  useEffect(() => {
    if (!query.isFetched) return
    if (query.data) setSession(query.data.user, query.data.workspace)
    else clear()
    markHydrated()
  }, [query.isFetched, query.data, setSession, clear, markHydrated])

  return query
}
